// extracted by mini-css-extract-plugin
export default {"tabs":"XTTvjyrq","tab":"_1btONEpx","active":"_2iws8coi"};